import { defineAsyncComponent } from 'vue';

const components = {};

const modules = require.context('@components-new', true, /index\.vue$/);

function toPascalCase(str) {
    return str
        .split('-')
        .map((word, index) => {
            return index === 0
                ? word.toLowerCase()
                : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('');
}

modules.keys().forEach((path) => {
    try {
        const name = toPascalCase(path.split('/').slice(-2, -1)[0]);

        components[name] = defineAsyncComponent(() => {
            return new Promise((resolve, reject) => {
                try {
                    resolve(modules(path));
                } catch (error) {
                    reject(error);
                }
            });
        });

    } catch (error) {
        console.error(`Ошибка при импорте компонента: ${path}`, error);
    }
});

export default components;
